import { environment } from '@env'


export const msalAuthConfig = {
    auth: {
        clientId: environment.azuread.clientId,
        authority: environment.azuread.authority,
        redirectUri: environment.azuread.redirectUri,
        postLogoutRedirectUri:  environment.azuread.postLogoutRedirectUri,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system:{
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        console.error(message);
                        break;
                    case 1:
                        console.warn(message);
                        break;
                    case 2:
                        console.info(message);
                        break;
                    case 3:
                        console.debug(message);
                        break;
                    default:
                        console.log(message);
                }
            },
            piiLoggingEnabled: false,
            logLevel: 0, // Error
        },
    }
};
